// import {useState} from 'react';
import {ContentIdeasStore} from '@/store/content-optimizer/contentIdeas';
import CsvDownloader from 'react-csv-downloader';
import {Divider} from 'antd';
import {observer} from 'mobx-react';
import styles from './style.module.scss';
import {SingleContentIdea} from './SingleContentIdea';
import {ExportOutlined} from '@ant-design/icons';
import {Button} from '@/components/common-components/components';

interface Props {
  store: ContentIdeasStore;
}

export const ContentIdeas = observer(({store}: Props) => {
  const csvModel = store?.wordsArray.map(item => ({
    title: item.split('\n')[0],
    text: item.split('\n')[1],
  }));

  const csvColumns = [
    {
      id: 'title',
      displayName: 'Title',
    },
    {
      id: 'text',
      displayName: 'Text',
    },
  ];
  return <>
    {store?.wordsArray.length ? <Divider className={styles.popoverDivider} /> : null}
    {store?.wordsArray.length ? <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}} className={styles.generatedItemsNumb}>
      <span>{`${store?.wordsArray?.length} ideas generated for "${store?.keyword}" `}</span>
      <CsvDownloader datas={csvModel} filename={`${store?.keyword}-contentideas`} columns={csvColumns}>
        <Button buttonType='light-gray' size='sm' style={{backgroundColor: '#fff', fontSize: '14px', color: '#4E5156'}}
        >
          <ExportOutlined style={{marginRight: '6px'}}/>
          Export all
        </Button>
      </CsvDownloader>
    </p> : null}
    {store?.wordsArray && store?.wordsArray.map((idea, idx) => {
      return <SingleContentIdea key={idx} idea={idea} />;
    })}
  </>;
});
